export default __webpack_public_path__ + "341d33d5974319a446c3358503eb5ea3.png";